import React, {useEffect, useCallback} from 'react';
import * as THREE from "three";
import {vertexShader, fragmentShader} from './shaders.js';

var renderer, scene, camera, clock, uniforms;
export const useShader = (ref) => {

    /*
     * Initializes the sketch
     */
    function init() {
	// Initialize the WebGL renderer
	renderer = new THREE.WebGLRenderer();
	renderer.setPixelRatio(window.devicePixelRatio);
	renderer.setSize(window.innerWidth/2, window.innerHeight/2);
        
	// Add the renderer to the sketch container
	ref.current.appendChild(renderer.domElement);
        
	// Initialize the scene
	scene = new THREE.Scene();
        
	// Initialize the camera
	camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        
	// Initialize the clock
	clock = new THREE.Clock(true);
        
	// Create the plane geometry
	var geometry = new THREE.PlaneBufferGeometry(2, 2);

		// Define the shader uniforms
		uniforms = {
			u_time : {
				type : "f",
				value : 0.0
			},
			u_frame : {
				type : "f",
				value : 0.0
			},
			u_resolution : {
				type : "v2",
				value : new THREE.Vector2(window.innerWidth, window.innerHeight)
						.multiplyScalar(window.devicePixelRatio)
			},
			u_mouse : {
				type : "v2",
				value : new THREE.Vector2(0.7 * window.innerWidth, window.innerHeight)
						.multiplyScalar(window.devicePixelRatio)
			}
		};

		// Create the shader material
		var material = new THREE.ShaderMaterial({
		    uniforms : uniforms,
		    vertexShader,
		    fragmentShader
		});

		// Create the mesh and add it to the scene
		var mesh = new THREE.Mesh(geometry, material);
		scene.add(mesh);

		// Add the event listeners
		window.addEventListener("resize", onWindowResize, false);
        /*
		renderer.domElement.addEventListener("mousemove", onMouseMove, false);
		renderer.domElement.addEventListener("touchstart", onTouchMove, false);
		renderer.domElement.addEventListener("touchmove", onTouchMove, false);
                */
	}

	/*
	 * Animates the sketch
	 */
	function animate() {
		requestAnimationFrame(animate);
		render();
	}

	/*
	 * Renders the sketch
	 */
	function render() {
		uniforms.u_time.value = clock.getElapsedTime();
		uniforms.u_frame.value += 1.0;
		renderer.render(scene, camera);
	}

	/*
	 * Updates the renderer size and the uniforms when the window is resized
	 */
	function onWindowResize(event) {
		// Update the renderer
		renderer.setSize(window.innerWidth, window.innerHeight);

		// Update the resolution uniform
		uniforms.u_resolution.value.set(window.innerWidth, window.innerHeight).multiplyScalar(window.devicePixelRatio);
	}
    useEffect(() => {
	init();
	animate();
    }, []);
}
